import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,[_c(VCol,[_c('DatePickerInput',{attrs:{"hide-details":_vm.hideDetails},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c(VCol,[_c('TimePickerInput',{attrs:{"use-native":"","hide-details":_vm.hideDetails},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }